<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import { user_info_list } from "../store/user_info_list.js";
    import { device_info } from "../store/device_info.js";

    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const fetch_data = async () => {
        console.log("contains", $user_info_list);

        if ($user_info_list && Object.keys($user_info_list).length > 0) {
            if (
                $user_info_list.connected_devices &&
                $user_info_list.connected_devices.length > 0
            ) {
                return $user_info_list;
            } else {
                user_info_list.set({});
            }
        }

        console.log("fetching data");

        var user_info_list_url = new URL(
            `${process.env.API_ROOT}/user/info/list`,
        );

        const user_info_list_response = await fetch(user_info_list_url, {
            headers: {
                Authorization: "Bearer " + $token,
            },
        });

        let json_response = await user_info_list_response.json();

        console.log("json", json_response);
        user_info_list.set(json_response);
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings Security Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Security"
            back_button_enabled={false}
        />
        <!--
        <div class="settings-heading">
            <div class="d-md-none">
                <div class="heading-block">
                    <a class="nav-opener" href="#"
                        ><i class="icon icon-navigation" /></a
                    ><a class="nav-back" href="#">
                        <div class="ico-holder">
                            <i class="icon icon-chevron-left" />
                        </div>
                        <div class="ico-holder">
                            <i class="icon icon-devices" />
                        </div>
                        <div class="title-holder">
                            <strong class="settings-title">Security</strong>
                        </div></a
                    >
                </div>
            </div>
            <div class="d-none d-md-block">
                <div class="heading-block">
                    <h1 class="h6 settings-title">Security</h1>
                </div>
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="intro-text text-small">
                        <p>
                            View and manage which devices have access to your
                            Vollume account
                        </p>
                    </div>
                    <div
                        class="card-settings-main card-h-100 card bg-transparent-mobile"
                    >
                        {#await fetch_data()}
                            <div class="card-body">
                                <nav>
                                    <ul
                                        class="nav-second-level nav-settings nav-text-hide-mobile"
                                    >
                                        <li>
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Loading
                                                                    devices</strong
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        {:then data}
                            <div class="card-body">
                                <nav>
                                    <ul
                                        class="nav-second-level nav-settings nav-text-hide-mobile"
                                    >
                                        {#each $user_info_list.connected_devices as connected_device}
                                            <li
                                                on:click={() => {
                                                    device_info.set(
                                                        connected_device,
                                                    );
                                                    set_section(
                                                        "account/security/device_detail",
                                                    );
                                                }}
                                            >
                                                <a
                                                    class="opener-third-level"
                                                    href="#"
                                                >
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col-auto">
                                                            <span
                                                                class="ico-holder"
                                                            >
                                                                {#if connected_device.device_platform == "android"}
                                                                    <img
                                                                        src="../images/Vector-1.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {:else if connected_device.device_platform == "macos" || connected_device.device_platform == "ios"}
                                                                    <img
                                                                        src="../images/Vector.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {:else}
                                                                    <img
                                                                        src="../images/Vector.svg"
                                                                        loading="lazy"
                                                                        alt=""
                                                                        class="device-icon"
                                                                        width="17"
                                                                        height="20"
                                                                    />
                                                                {/if}
                                                            </span>
                                                        </div>
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                        style="padding-right:0px;"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >{connected_device.device_name ==
                                                                            null
                                                                                ? "unknown"
                                                                                : connected_device.device_name}</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                Recent
                                                                                Activity
                                                                                –
                                                                                {connected_device.location}
                                                                                –
                                                                                {new Date(
                                                                                    connected_device.created_at,
                                                                                ).toDateString()}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                        style="padding-left:0px"
                                                                    >
                                                                        <i
                                                                            class="icon icon-chevron-right"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div></a
                                                >
                                            </li>
                                        {/each}
                                    </ul>
                                </nav>
                            </div>
                        {:catch error}
                            <p>Failed to load the list.</p>
                        {/await}
                    </div>
                </div>
                <!--<div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <a class="btn btn-primary" href="#"
                            >Connect New Device</a
                        >
                    </div>
                </div>-->
            </div>
        </div>
    </div>
    <!-- Settings Security Device Details (Second Level)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Device details</strong>
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-details card-join-bottom card">
                        <div class="card-body">
                            <div class="device-ico-holder">
                                <div class="ico-holder">
                                    <img
                                        src="images/avatar-apple.svg"
                                        alt="Apple"
                                        width="40"
                                        height="48"
                                    />
                                </div>
                            </div>
                            <strong class="h5 card-title">Jacobs iPhoneX</strong
                            >
                            <dl class="list-details">
                                <dt>Recent Activity</dt>
                                <dd>
                                    <span class="place-activity"
                                        >Zlin, Czechia</span
                                    >–<span class="time-activity"
                                        >About an hour ago.</span
                                    >
                                </dd>
                            </dl>
                            <dl class="list-details">
                                <dt>Connected</dt>
                                <dd>
                                    <time
                                        class="time-activity"
                                        datetime="2020-08-02">2 Aug, 2020</time
                                    >
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    You will be logged out from <span
                                        class="text-white">Jacobs iPhoneX</span
                                    > device
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-danger" href="#"
                                    >Disconnect Device</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
